import { isSuccess } from '@/context/services/type';
import { useCancelInvoiceReport as useBaseCancelInvoiceReport } from 'ap-openapi';
import { useCallback } from 'react';

export const useCancelInvoiceReportService = () => {
  const { mutateAsync: _mutateAsync } = useBaseCancelInvoiceReport();
  const mutateAsync = useCallback(
    async (id: string) => {
      const resp = await _mutateAsync({ id });
      if (!isSuccess(resp.status)) {
        const errorData =
          typeof resp.data === 'object' && resp.data !== null ? resp.data : {};
        throw { ...errorData, statusCode: resp.status };
      }
    },
    [_mutateAsync]
  );
  return { mutateAsync };
};
